import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotComicsSection from './components/HotComicsSection';
import NewComicsSection from './components/NewComicsSection';
import AllComicsSection from './components/AllComicsSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫网',
    url: 'https://hanmanwang.com',
    description: '韩国漫画全集免费在线阅读平台，支持下拉式浏览，让您畅读好看的韩漫大全',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hanmanwang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫网',
    url: 'https://hanmanwang.com',
    description: '韩国漫画全集免费在线阅读平台',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <HeroSection />
        <CategoryNav />
        <HotComicsSection />
        <NewComicsSection />
        <AllComicsSection />
        <NewsletterSection />
      </main>
    </>
  );
}